import { Color, Uniform, UniformsLib, UniformsUtils } from "three";
import { GLOBAL_UNIFORMS } from "../../shader/GlobalUniforms";
import { INSTANCE_VERTEX_SHADER, INSTANCE_FRAGMENT_SHADER, INSTANCE_DEPTH_VERTEX_SHADER, INSTANCE_DEPTH_FRAGMENT_SHADER } from "./instance.shader";
// duration for clip tween in milliseconds;
export const CLIP_TWEEN_DURATION = 1000;
export var PrimitiveMeshAttributes;
(function (PrimitiveMeshAttributes) {
    PrimitiveMeshAttributes[PrimitiveMeshAttributes["position"] = 0] = "position";
    PrimitiveMeshAttributes[PrimitiveMeshAttributes["orientation"] = 1] = "orientation";
    PrimitiveMeshAttributes[PrimitiveMeshAttributes["scale"] = 2] = "scale";
    PrimitiveMeshAttributes[PrimitiveMeshAttributes["clipFade"] = 3] = "clipFade";
    PrimitiveMeshAttributes[PrimitiveMeshAttributes["color"] = 4] = "color";
})(PrimitiveMeshAttributes || (PrimitiveMeshAttributes = {}));
export const PRIMITIVE_MESH_INSTANCE_SHADER = {
    uniforms: UniformsUtils.merge([
        /* we need at least some of these to use threes fragments and not get undefined errors */
        UniformsLib.common,
        UniformsLib.lights,
        {
            cameraCenterWorldPosition: new Uniform({}),
            platformScale: new Uniform({}),
            time: new Uniform({}),
            // we interpolate on GPU
            clipTweenDuration: new Uniform(CLIP_TWEEN_DURATION),
            // common parameters for phong based lighting
            emissive: new Uniform(new Color(0x111111)),
            specular: new Uniform(new Color(0x000000)),
            shininess: new Uniform(256),
            // fill: { value: new Color(color) },
            stroke: new Uniform(new Color(1, 1, 1)),
            thickness: new Uniform(0.01)
        }
    ]),
    vertexShader: INSTANCE_VERTEX_SHADER,
    fragmentShader: INSTANCE_FRAGMENT_SHADER,
    depthVertexShader: INSTANCE_DEPTH_VERTEX_SHADER,
    depthFragmentShader: INSTANCE_DEPTH_FRAGMENT_SHADER,
    attributes: [
        // position in room coordinates
        {
            name: "instancePosition",
            size: 3,
            type: Float32Array,
            normalized: false
        },
        // orientation in room coordinates
        {
            name: "instanceOrientation",
            size: 4,
            type: Float32Array,
            normalized: false
        },
        // scale in room coordinates
        { name: "instanceScale", size: 3, type: Float32Array, normalized: false },
        // // to smoothly animate the near clipping feature.
        // x = soruce (0 for fully visible 1 for fade till center, 2 for fully invisible)
        // y = target (same)
        // z = tween until this time is reached
        {
            name: "instanceClipFade",
            size: 3,
            type: Float32Array,
            normalized: false
        },
        // the color of the instance, normalized to 0..1
        { name: "instanceColor", size: 3, type: Uint8Array, normalized: false }
    ]
};
// UniformsUtils.merge() will clone the uniform,
// but we want some of the uniform use the some objects
// therefore we have to override some uniforms.
PRIMITIVE_MESH_INSTANCE_SHADER.uniforms.cameraCenterWorldPosition = GLOBAL_UNIFORMS.cameraCenterWorldPosition;
PRIMITIVE_MESH_INSTANCE_SHADER.uniforms.platformScale = GLOBAL_UNIFORMS.platformScale;
PRIMITIVE_MESH_INSTANCE_SHADER.uniforms.time = GLOBAL_UNIFORMS.time;
